import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-blog-single',
  templateUrl: './breadcrumb-blog-single.component.html',
  styleUrls: ['./breadcrumb-blog-single.component.scss']
})
export class BreadcrumbBlogSingleComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
